import {z} from 'zod';
import {BUILDER_PROMPT_MAX_LENGTH} from '@packages/systems/ai/workflows/shared';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../types/base-tool-types';

const toolName = 'build-workflow' as const;

const argumentZod = z.object({
  // Bounded to match the REST route: the tool wrappers call the handler
  // directly, so an unbounded string here would be a way around it.
  prompt: z
    .string()
    .trim()
    .min(1)
    .max(BUILDER_PROMPT_MAX_LENGTH)
    .describe(
      'Natural-language description of the workflow to build (trigger, steps, and outputs).'
    ),
  triggerType: z
    .enum(['form_submission', 'collection_item_published'])
    .optional()
    .describe(
      'Which Webflow event triggers the workflow. Defaults to form_submission.'
    ),
});

export const buildWorkflowManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Build AI workflow',
  family: 'workflows',
  llmTool: {
    name: toolName,
    description:
      'Builds a new AI workflow for the current site from a natural-language description. The workflow is created as a DRAFT and does NOT go live until the user saves it in the Designer, so tell the user their agent is ready to review and save. Returns the workflow ID plus the draft ID and revision it was written to.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AIA_WORKFLOWS_MCP,
  confirmBeforeExecuting: false,
});

export type BuildWorkflowArgumentType = z.infer<typeof argumentZod>;
